import * as actionTypes from "./globalActionTypes";

export const fetchSummary = () => ({
  type: actionTypes.fetchSummaryType

});

export const fetchAccountData = payload => ({
  type: actionTypes.fetchAccountDataType,
  payload
});

export const globalAccountSummaryLoading = payload => ({
  type: actionTypes.globalSetAccountDataLoadingType
})

export const fetchAccountAdvisors = payload => ({
  type: actionTypes.fetchAccountAdvisorsType,
  payload
});

export const accountDataRequestFailed = payload => ({
  type: actionTypes.accountDataRequestFailedType,

  payload
});

export const updateActiveFlow = payload => ({
  type: actionTypes.updateActiveFlowType,
  payload
});

export const updateActivePage = payload => ({
   type: actionTypes.updateActivePageType,
   payload
});

export const updateActivePageStepNumber = payload => ({
  type:actionTypes.updateActivePageStepNumberType,
  payload
});

export const updateStepperConfig = payload => ({
  type: actionTypes.updateStepperConfigType,
  payload
});

export const updatePageStepToFinish = () => ({
  type: actionTypes.updatePageSteptoFinishType
});

export const updatePageStepToProcess = () => ({
  type: actionTypes.updatePageStepToProcessType
});

export const changeAccountStatus = () => ({
  type: actionTypes.changeAccountStatusType
})

export const showPopUp = () => ({
  type: actionTypes.showPopupType
});

export const hidePopUp = () => ({
  type: actionTypes.hidePopupType
});

export const DecrementCountDown = () => ({
  type: actionTypes.decrementTimerType
});

export const logoutSessionFlush = payload => ({
  type: actionTypes.logoutSessionFlushType,
  payload,
});

export const accountChange = payload => ({
  type: actionTypes.accountChangeType,
  payload,
});

export const clearGlobalData = () => ({
  type: actionTypes.exitExchangeType
});

export const postCoachMarks = payload => ({
  type: actionTypes.postCoachMarksType,
  payload,
});


export const selectHeader = payload => ({
  type: actionTypes.headerDataType,
  payload,
});

export const updateStepperIndex = payload => ({
  type: actionTypes.updateStepperIndexType,
  payload
})


export const editStepperIndex = payload => ({
  type: actionTypes.editStepperIndexType,
  payload
})

export const clearGlobalError = payload => ({
  type:actionTypes.clearGlobalErrorType,
})

export const hideErrorModal = payload => ({
  type:actionTypes.hideErrorModalType
})


export const handleServerError = (payload)=> ({
  type:actionTypes.handleServerError,
  payload
})


//--------getAttributesForCSR------------//


export const attributesForCSR = payload => ({
  type: actionTypes.getCSRDataType,
  payload,
});
export const myAccountDetailsSuccess = payload => ({
  type: actionTypes.fetchAccountDetailsDataType,
  payload,
});


export const makeUserSessionSuccess = () => ({
  type: actionTypes.makeUserSessionSuccessType
});

export const pullBusinessFunctionForCSR = payload => ({
  type: actionTypes.pullBusinessFunctionForCsrType,
  payload
});

export const updateStepperAllToFinish = payload => ({
  type:actionTypes.updateStepperAllToFinishType,
  payload
})


export const availableBalance = payload => ({
  type: actionTypes.getAvailableBalanceType,
  payload
})

export const primaryAccountChanged = payload => ({
  type: actionTypes.primaryAccountChangedType,
  payload
});

export const modifyStepperConfig = payload => ({
  type: actionTypes.modifyStepperConfigType,
  payload
});

export const fetchCodeValueMapping = payload => ({
  type:actionTypes.fetchCodeValueMappingType,
  payload
})

export const resetStepperIndex = () => ({
  type: actionTypes.resetStepperStateType
})

export const fetchUserInfo = (payload='') => ({
  type: actionTypes.fetchUserInfoType,
  payload: payload
})

export const fetchDropdownValues = payload => ({
	type: actionTypes.fetchDropDownValType,
	payload
  });